/**
 * @file DarkModeButton.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente del botón de modo oscuro
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-06-04
 * @author DLTCode
 * @author Diego Sánchez
 * @copyright © DLTCode
 * @license Private
 * */
"use client";

import { useTranslations } from "next-intl";
import { useTheme } from "@/context/ThemeProvider";

interface DarkModeButtonProps {
  ariaLabel?: string;
}
export default function DarkModeButton({ ariaLabel }: DarkModeButtonProps) {
  const t = useTranslations("AriaLabel");
  const { isDark, toggle } = useTheme();
  const label = ariaLabel || t("darkButton");

  return (
    <section role="region" aria-label={label} className="dark-mode-button">
      <label
        className="switch"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <input
          type="checkbox"
          className="input"
          role="switch"
          checked={isDark}
          onChange={toggle}
          aria-label={label}
        />
        <span className="slider">
          <span className="sun">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              role="img"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 1.5V3.375M14.3033 3.6967L12.9775 5.02252M16.5 9H14.625M14.3033 14.3033L12.9775 12.9775M9 14.625V16.5M5.02252 12.9775L3.6967 14.3033M3.375 9H1.5M5.02252 5.02252L3.6967 3.6967M12.125 9C12.125 10.7259 10.7259 12.125 9 12.125C7.27411 12.125 5.875 10.7259 5.875 9C5.875 7.27411 7.27411 5.875 9 5.875C10.7259 5.875 12.125 7.27411 12.125 9Z"
                stroke="#005fab"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="moon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              role="img"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
                stroke="#CCDFEE"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </span>
      </label>
    </section>
  );
}
